import api from '@/api/api';

export default {

  namespaced: true,

  state: {
    cuentas: [],
  },
  mutations: {

    getCuentas(state, datos) {
      state.cuentas = datos;
    },

    destroyCuentas(state) {
      state.cuentas = [];
    },

  },
  actions: {
    async destroyCuentas({ commit }) {
      commit('destroyCuentas');
    },

    async getCuentas({
      commit,
    }) {
      try {
        const res = await api.getCuentas();
        // console.log(object);
        if (res.data.DATOS) {
          commit('getCuentas', res.data.DATOS);
          return [true];
        } return [false];
      } catch (error) {
        return [false, 'errorcarga'];
      }
    },

    async insertCuentas({ }, acc) {
      try {
        const res = await api.insertCuentas(acc);
        if (res.data.INFO.cod === '200') {
          return [true, 'blah'];
        } return [false, res.data.INFO.msg];
      } catch (error) {
        console.log(error);
      }
    },

    async deleteCuentas({ commit }, acc) {
      try {
        const res = await api.deleteCuentas(acc);
        // commit('deleteSucursales', res.data.sucursal);
        if (res.data.INFO.cod === '200') {
          return [true, 'blah'];
        } return [false, res.data.INFO.msg];
      } catch (error) {
        console.log(error);
      }
    },

    async editCuentas({ }, acc) {
      try {
        const res = await api.editCuentas(acc);
        if (res.data.INFO.cod === '200') {
          return [true, 'blah'];
        } return [false, res.data.INFO.msg];
      } catch (error) {
        console.log(error);
      }
    },

  },
};
